@let label = labelSg();
@let enum = inlineEnumSg();

<atn-inline-enum-input
  [label]="label"
  [(value)]="valueSg"
  [enum]="enum"
/>
